import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-250);
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  gap: var(--space-250);
`

export const Title = styled.div`
  color: var(--text-primary);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);
`

export const Limit = styled.div<{ isFull?: boolean }>`
  color: var(--text-secondary);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);

  ${({ isFull }) =>
    isFull &&
    css`
      color: var(--text-alert-secondary);
    `}
`

export const Bar = styled.div<{ isFull?: boolean; completionPercentage: number }>`
  width: 100%;
  height: 10px;
  border-radius: var(--radius-brand);
  background: var(--bg-transparent-strong);
  position: relative;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: ${({ completionPercentage }) => completionPercentage}%;
    background: var(--bg-quaternary);
    min-width: 4px;
    max-width: calc(100% - 4px);
  }

  ${({ isFull }) =>
    isFull &&
    css`
      &:after {
        background: var(--bg-alert);
        max-width: 100%;
      }
    `}
`
